import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import { loading } from '@/shared/utils/UIHelper'

import ExpenseTyeRepository from '@/shared/http/repositories/configuration/expensetype'
import ExpenseTyeModel from '@/shared/models/configuration/expensetyemodel'
import ExpenseTyeForms from './expensetype-form.js'

export default {
  name: 'ExpenseType',
  mixins: [ActionsForm],
  data () {
    return {
      data: ExpenseTyeModel,
      form: ExpenseTyeForms
    }
  },
  computed: {
    FieldSizeTip: function () {
      return this.$lang.Common.Tips.MaximumSize.replace('@SIZE@', this.form.descricao.maxlength)
    }
  },
  methods: {
    onLoad () {
      loading.push()
      ExpenseTyeRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onEdit (obj) {
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      this.form.categoria.value = obj.categoria
      this.form.forma.value = obj.forma
      loading.close()
    },
    onCreate () {
      loading.push()
      ExpenseTyeRepository.Create(this.data)
        .then(this.onResult)
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      ExpenseTyeRepository.Update(this.data)
        .then(this.onResult)
        .catch(this.onException)
    },
    onDelete (obj) {
      loading.push()
      ExpenseTyeRepository.Delete(obj.id)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/expensetype/expensetype.js